import { assert } from '@ember/debug';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

export interface CheckboxControlSignature {
  Element: HTMLInputElement;
  Args: {
    id?: string;
    styles?: string;
    onChange?: (value: boolean, e: Event | InputEvent) => void;
    isChecked?: boolean;
  };
}

export default class WrFormControlsCheckboxComponent extends Component<CheckboxControlSignature> {
  handleInput = (e: Event | InputEvent): void => {
    assert('Expected HTMLInputElement', e.target instanceof HTMLInputElement);

    this.args.onChange?.(e.target.checked, e);
  };

  get styles() {
    return [
      this.args.styles,
      'form-checkbox',
      'checked:bg-checkbox',
      'rounded',
      'checked:border',
      'checked:border-black',
      'checked:text-white',
      'checked:hover:border-black',
      'focus:border-none',
      'focus:ring-black',
      'focus:ring-offset-0',
      'checked:focus:border-black'
    ].join(' ');
  }

  <template>
    <input
      id={{@id}}
      type='checkbox'
      class={{this.styles}}
      checked={{@isChecked}}
      {{on 'change' this.handleInput}}
      ...attributes
    />
  </template>
}
